import React, { useState, useEffect } from "react";
import "../../../styles/Part5DirectReading.css";
import { pattern1Data } from "../../../data/sentencePatterns/pattern1";
import { pattern2Data } from "../../../data/sentencePatterns/pattern2";
import { pattern3Data } from "../../../data/sentencePatterns/pattern3";
import { pattern4Data } from "../../../data/sentencePatterns/pattern4";
import { pattern5Data } from "../../../data/sentencePatterns/pattern5";
import { pattern6Data } from "../../../data/sentencePatterns/pattern6";
import { pattern7Data } from "../../../data/sentencePatterns/pattern7";
import { pattern8Data } from "../../../data/sentencePatterns/pattern8";
import { pattern9Data } from "../../../data/sentencePatterns/pattern9";
import { pattern10Data } from "../../../data/sentencePatterns/pattern10";
import { pattern11Data } from "../../../data/sentencePatterns/pattern11";
import { pattern12Data } from "../../../data/sentencePatterns/pattern12";
import { pattern13Data } from "../../../data/sentencePatterns/pattern13";
import { pattern14Data } from "../../../data/sentencePatterns/pattern14";
import { pattern15Data } from "../../../data/sentencePatterns/pattern15";
import { pattern16Data } from "../../../data/sentencePatterns/pattern16";
import { db } from "../../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useAuth } from "../../../contexts/AuthContext";

const Part5_DirectReading = ({ onBack, patternId }) => {
  const [revealedKoreanChunks, setRevealedKoreanChunks] = useState([]);
  const [hiddenEnglishChunks, setHiddenEnglishChunks] = useState([]);
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
  const { currentUser } = useAuth();
  const [showCompletionModal, setShowCompletionModal] = useState(false);

  // patternId 타입을 확인하고 강제로 숫자로 변환
  const id = Number(patternId);

  // 데이터 선택 로직 수정
  let sentences;
  let title;

  if (id === 1) {
    sentences = pattern1Data;
    title = "1형식 (S + V)";
  } else if (id === 2) {
    sentences = pattern2Data;
    title = "2형식 (S + V + SC)";
  } else if (id === 3) {
    sentences = pattern3Data;
    title = "3형식 (S + V + O)";
  } else if (id === 4) {
    sentences = pattern4Data;
    title = "4형식 (S + V + IO + DO)";
  } else if (id === 5) {
    sentences = pattern5Data;
    title = "5형식 (S + V + O + OC)";
  } else if (id === 6) {
    sentences = pattern6Data;
    title = "긴 주어 읽기";
  } else if (id === 7) {
    sentences = pattern7Data;
    title = "시제 (Tense)";
  } else if (id === 8) {
    sentences = pattern8Data;
    title = "가정법 및 도치 (Conditionals & Inversion)";
  } else if (id === 9) {
    sentences = pattern9Data;
    title = "전치사, 접속부사, 접속사 (Prepositions & Conjunctions)";
  } else if (id === 10) {
    sentences = pattern10Data;
    title = "동명사, to부정사 (Gerund & Infinitive)";
  } else if (id === 11) {
    sentences = pattern11Data;
    title = "분사구문 (Participle Phrase)";
  } else if (id === 12) {
    sentences = pattern12Data;
    title = "관계사, 관계부사, 분사 등 '수식하는 문장' 해석";
  } else if (id === 13) {
    sentences = pattern13Data;
    title = "문법구분없는 토익문장";
  } else if (id === 14) {
    sentences = pattern14Data;
    title = "접속사, 부사절 접속사";
  } else if (id === 15) {
    sentences = pattern15Data;
    title = "지시대명사, 부정대명사";
  } else if (id === 16) {
    sentences = pattern16Data;
    title = "병렬구조 (Parallel Structure)";
  }

  const currentSentence = sentences[currentSentenceIndex];

  const handleKoreanChunkClick = (index) => {
    if (revealedKoreanChunks.includes(index)) {
      setRevealedKoreanChunks(revealedKoreanChunks.filter((i) => i !== index));
    } else {
      setRevealedKoreanChunks([...revealedKoreanChunks, index]);
    }
  };

  const handleEnglishChunkClick = (index) => {
    if (hiddenEnglishChunks.includes(index)) {
      setHiddenEnglishChunks(hiddenEnglishChunks.filter((i) => i !== index));
    } else {
      setHiddenEnglishChunks([...hiddenEnglishChunks, index]);
    }
  };

  const handleNext = () => {
    if (currentSentenceIndex < sentences.length - 1) {
      setCurrentSentenceIndex(currentSentenceIndex + 1);
      setRevealedKoreanChunks([]);
      setHiddenEnglishChunks([]);
    }
  };

  const handlePrev = () => {
    if (currentSentenceIndex > 0) {
      setCurrentSentenceIndex(currentSentenceIndex - 1);
      setRevealedKoreanChunks([]);
      setHiddenEnglishChunks([]);
    }
  };

  const markCategoryAsCompleted = async () => {
    if (!currentUser) return;

    try {
      const userDocRef = doc(db, "users", currentUser.uid);
      await updateDoc(userDocRef, {
        [`part5.partsOfSpeech.${patternId}.completed`]: true,
      });

      setShowCompletionModal(true); // 완료 후 모달 표시
    } catch (error) {
      console.error("완료 상태 저장 중 오류:", error);
    }
  };

  const handleConfirmCompletion = () => {
    setShowCompletionModal(false);
    onBack(); // 확인 후 뒤로 가기
  };

  const handleContinueLearning = () => {
    setShowCompletionModal(false); // 모달만 닫고 현재 페이지에 남음
  };

  const isLastSentence = currentSentenceIndex === sentences.length - 1;

  useEffect(() => {
    // 빈 useEffect 유지
  }, [patternId]);

  return (
    <div className="direct-reading-container">
      <button className="back-button" onClick={onBack}>
        ← 뒤로가기
      </button>

      <h2>{title} 직독직해 연습</h2>

      <div className="sentence-container">
        <div className="english-chunks">
          {currentSentence.englishChunks.map((chunk, index) => (
            <span
              key={index}
              className={`chunk ${
                hiddenEnglishChunks.includes(index) ? "hidden" : ""
              }`}
              onClick={() => handleEnglishChunkClick(index)}
            >
              {hiddenEnglishChunks.includes(index) ? "___" : chunk}
            </span>
          ))}
        </div>

        <div className="korean-chunks">
          {currentSentence.koreanChunks.map((chunk, index) => (
            <span
              key={index}
              className={`chunk ${
                revealedKoreanChunks.includes(index) ? "revealed" : "hidden"
              }`}
              onClick={() => handleKoreanChunkClick(index)}
            >
              {revealedKoreanChunks.includes(index) ? chunk : "___"}
            </span>
          ))}
        </div>

        {revealedKoreanChunks.length === currentSentence.koreanChunks.length &&
          hiddenEnglishChunks.length === 0 && (
            <>
              <div className="full-sentence">{currentSentence.fullEnglish}</div>
              {currentSentence.additionalExplanation && (
                <div className="additional-explanation">
                  <h4>추가 설명:</h4>
                  <p>{currentSentence.additionalExplanation}</p>
                </div>
              )}
            </>
          )}
      </div>

      <div className="navigation-buttons">
        <button onClick={handlePrev} disabled={currentSentenceIndex === 0}>
          이전
        </button>
        <span>
          {currentSentenceIndex + 1} / {sentences.length}
        </span>
        {isLastSentence ? (
          <button onClick={markCategoryAsCompleted} className="complete-button">
            학습 완료
          </button>
        ) : (
          <button
            onClick={handleNext}
            disabled={currentSentenceIndex === sentences.length - 1}
          >
            다음
          </button>
        )}
      </div>

      {/* 완료 확인 모달 */}
      {showCompletionModal && (
        <div className="completion-modal">
          <div className="modal-content">
            <h3>학습 완료!</h3>
            <p>학습이 성공적으로 완료되었습니다.</p>
            <p>카테고리로 돌아가시겠습니까?</p>
            <div className="modal-buttons">
              <button onClick={handleConfirmCompletion}>카테고리로 이동</button>
              <button onClick={handleContinueLearning}>계속 학습하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Part5_DirectReading;
